export function renderCCMonths() {
  const months = Array.from({ length: 12 }, (_, idx) => idx + 1);
  return months.map((m) => (
    <option key={`month-${m}`} value={m.toString()}>
      {String(m).padStart(2, "0")}
    </option>
  ));
}
